module.exports = __webpack_public_path__ + "img/amb_bg3.086b8c0b.png";